
<template>
  <div class="input-tag-container" :class="{ 'input-tag-container--active': isInputActive }">
    <!-- <i class="iconfont iconwuliao-shanchu color-alert" v-if="clearBtnVisible" @click="clearFn"></i> -->
    <div
      @click.stop="focusNewTag"
      :class="{
        'read-only': readOnly,
        'vue-input-tag-wrapper--active': isInputActive,
        'none-select': isShift
      }"
      :style="{ height: inputHeight, maxHeight }"
      class="vue-input-tag-wrapper"
      @scroll="scrollFn"
    >
      <div v-for="(tag, index) in innerTags" :key="index" :data-index="index" class="input-tag-item">
        <span
          @click="changeActive(index)"
          :class="{ 'input-tag-active': selectIndexArr.includes(index) || activeIndex === index, 'input-tag-error': validateTag(tag) }"
          class="input-tag"
        >
          <span @dblclick.stop="changeEdit(index)" :data-index="index" v-if="index !== editIndex">{{ tag }}</span>
          <input
            type="text"
            class="edit-tag"
            ref="input"
            v-if="index === editIndex"
            :value="tag"
            @blur="modifyTag"
            @keydown.stop
            @keyup.esc.stop="notModify(tag)"
            @keyup.enter.stop="modifyTag"
          />
          <a v-if="!readOnly" @click.prevent.stop="remove(index)" class="remove">
            <slot name="remove-icon" />
          </a>
        </span>
      </div>
      <span
        v-show="(newTag.length && isInputActive && clearBtnVisible) || (innerTags.length && isInputActive && clearBtnVisible)"
        class="del-btn"
        @click="clearFn"
        :style="{ top: scrollTop + 'px', bottom: -scrollTop + 'px' }"
      >
        <span class="icon-container">
          <i v-show="clearBtnVisible" class="iconfont iconshanchu"></i>
        </span>
      </span>
      <textarea
        v-if="!readOnly && !isLimit"
        ref="inputtag"
        :placeholder="computedPlaceholder"
        style="resize:none"
        rows="5"
        cols="120"
        v-model.trim="newTag"
        @paste="pasteFn"
        @keydown.delete.stop="removeLastTag"
        @keydown.stop="addNew"
        @blur="handleInputBlur"
        @focus="handleInputFocus"
        class="new-tag"
      />
    </div>
  </div>
</template>

<script>
import { copyText } from '@utils/common'
const validators = {
  email: new RegExp(/^(([^<>()[\]\\.,:\s@\"]+(\.[^<>()[\]\\.,:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  url: new RegExp(/^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i),
  text: new RegExp(/^[a-zA-Z]+$/),
  digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  isodate: new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/),
  codeName: /^([a-zA-Z0-9_]{1,20})$/,
  orderName: /^([a-zA-Z0-9_]{1,19})$/,
  isOrderNumber: /^([0-9]{1,19})$/,
  isNumber: /^([0-9_]{1,20})$/
}

export default {
  name: 'BaseInputTag',
  props: {
    value: {
      type: [Array, String],
      default: () => []
    },
    placeholder: {
      type: String,
      default() {
        return this.$lang('多单号用英文逗号或回车隔开，单次最多可输入10个运单号')
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    validate: {
      type: [String, Function, Object],
      default: 'codeName'
    },
    addTagOnKeys: {
      type: Array,
      default: function() {
        return [
          13, // Return
          188, // Comma ','
          9, // Tab
          32 // black space
        ]
      }
    },
    addTagOnBlur: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: -1
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    beforeAdding: {
      type: Function
    },
    maxHeight: {
      type: String,
      default: '180px'
    },
    clearBtnVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      newTag: '',
      innerTags: [...this.value],
      selectIndexArr: [],
      isInputActive: false,
      activeIndex: -1,
      editIndex: -1,
      isFocus: false,
      isCtrl: false,
      isShift: false,
      scrollTop: 0
    }
  },
  computed: {
    isLimit() {
      return this.limit > 0 && Number(this.limit) === this.innerTags.length
    },
    computedPlaceholder() {
      if (!this.innerTags.length) {
        return this.placeholder
      }
      return ''
    },
    inputHeight() {
      const wrapperDom = document.querySelector('.vue-input-tag-wrapper')
      if (this.isInputActive && wrapperDom.clientHeight < 100 && !this.innerTags.length) {
        return '100px'
      }
      if (!this.isInputActive) {
        return '28px'
      }
      return 'auto'
    }
  },
  watch: {
    value() {
      this.innerTags = [...this.value]
    },
    selectIndexArr(newVal) {
      if (newVal.length > 1) {
        this.activeIndex = -1
      }
    },
    activeIndex(newVal) {
      if (newVal !== -1) {
        this.selectIndexArr = []
      }
    }
  },
  methods: {
    scrollFn(e) {
      this.scrollTop = e.target.scrollTop
    },
    clearFn() {
      this.innerTags = []
      this.newTag = ''
      this.tagChange()
    },
    changeEdit(index) {
      this.editIndex = index
      setTimeout(() => {
        const editTagDom = document.querySelector('.edit-tag')
        if (editTagDom) {
          editTagDom.focus()
          editTagDom.select()
        }
      }, 300)
    },
    async modifyTag() {
      const value = document.querySelector('.edit-tag').value
      const isValid = await this.validateIfNeeded(value)
      if (isValid) {
        this.innerTags[this.editIndex] = value
        this.tagChange()
        this.editIndex = -1
        this.focusNewTag()
      }
    },
    notModify() {
      this.editIndex = -1
    },
    selectTag(index) {
      if (this.selectIndexArr.includes(index)) {
        const arr = this.selectIndexArr.filter(item => index !== item)
        this.selectIndexArr = arr
      } else {
        this.selectIndexArr.push(index)
      }
      if (this.activeIndex !== -1) {
        this.selectIndexArr.push(this.activeIndex)
      }
      this.selectIndexArr = this.selectIndexArr.sort((a, b) => a - b)
      this.activeIndex = -1
      this.isFocus = true
      if (!this.isInputActive) {
        this.isInputActive = true
      }
    },
    changeActive(index) {
      if (this.isCtrl || this.isShift) return
      this.selectIndexArr = []
      this.activeIndex = index
      this.isFocus = true
      if (!this.isInputActive) {
        this.isInputActive = true
      }
    },
    pasteFn(e) {
      setTimeout(async () => {
        const value = e.target.value
        if (value) {
          let tags = value.split(/[\s\n]/)
          tags = tags.join(',').split(',')
          tags = tags.join('，').split('，')
          tags.forEach(async element => {
            const isValid = await this.validateIfNeeded(element)
            if (isValid) {
              this.innerTags = [...new Set([...this.innerTags, ...tags.filter(element => element)])]
              this.tagChange()
              e.target.value = ''
              this.newTag = ''
            }
          })
        }
      }, 100)
    },
    focusNewTag(e) {
      this.isInputActive = true
      const generateIndex = (start, end) => {
        for (let i = start; i < end; i++) {
          this.selectIndexArr.push(i)
        }
      }
      if (e && e.target) {
        const dataIndex = e.target.getAttribute('data-index')
        if (this.isCtrl && dataIndex) {
          this.selectTag(Number(dataIndex))
        }
        if (this.isShift && this.activeIndex !== -1) {
          if (this.activeIndex < dataIndex) {
            generateIndex(Number(this.activeIndex), Number(dataIndex) + 1)
          } else {
            generateIndex(Number(dataIndex), Number(this.activeIndex) + 1)
          }
        }
        // console.log(dataIndex)
        // if (dataIndex) {
        //   return
        // }
      }
      this.isFocus = true
      // if (this.readOnly || !this.$el.querySelector('.new-tag')) {
      //   return
      // }
      this.$el.querySelector('.new-tag').focus()
    },
    blurTag() {
      this.isFocus = false
      this.isInputActive = false
    },
    handleInputFocus() {
      this.activeIndex = -1
      this.selectIndexArr = []
      this.isInputActive = true
    },
    handleInputBlur(e) {
      this.addNew(e)
    },
    copyText() {
      if (this.activeIndex !== -1) {
        return copyText(this.innerTags[this.activeIndex])
      }
      const arr = this.innerTags.filter((item, index) => this.selectIndexArr.includes(index))
      copyText(arr.join(' '))
    },
    async addNew(e) {
      // ctrl + c 复制
      if (e.keyCode === 67 && e.ctrlKey) {
        this.copyText()
      }
      // ctrl + a 权限
      if (e.keyCode === 65 && e.ctrlKey) {
        this.selectIndexArr = this.innerTags.map((item, index) => index)
        this.$nextTick(() => {
          e && e.preventDefault()
          this.$el.querySelector('.new-tag').blur()
        })
      }
      // 左键改变选择项
      if (e.keyCode === 37 && !this.newTag) {
        this.activeIndex = this.innerTags.length - 1
        this.$refs.inputtag.blur()
      }

      const keyShouldAddTag = e ? this.addTagOnKeys.indexOf(e.keyCode) !== -1 : true

      const typeIsNotBlur = e && e.type !== 'blur'

      if ((!keyShouldAddTag && (typeIsNotBlur || !this.addTagOnBlur)) || this.isLimit) {
        return
      }
      // 添加标签
      const tag = this.beforeAdding ? await this.beforeAdding(this.newTag) : this.newTag.trim()
      const isValid = await this.validateIfNeeded(tag)
      if (tag && isValid && (this.allowDuplicates || this.innerTags.indexOf(tag) === -1)) {
        this.innerTags.push(tag)
        this.newTag = ''
        this.tagChange()
        this.activeIndex = -1
        document.querySelector('.vue-input-tag-wrapper').scrollTop = 1000
        e && e.preventDefault()
      }
    },
    validateTag(tag) {
      if (this.validate) {
        return !validators[this.validate].test(tag)
      }
      return false
    },
    validateIfNeeded(tagValue) {
      if (this.validate === '' || this.validate === undefined) {
        return true
      }

      if (typeof this.validate === 'function') {
        return this.validate(tagValue)
      }

      if (typeof this.validate === 'string' && Object.keys(validators).indexOf(this.validate) > -1) {
        return validators[this.validate].test(tagValue)
      }

      if (typeof this.validate === 'object' && this.validate.test !== undefined) {
        return this.validate.test(tagValue)
      }
      return true
    },
    changeTag(e) {
      // ctrl + c 复制
      if (e.keyCode === 67 && e.ctrlKey) {
        this.copyText()
      }
      if (this.isFocus) {
        if (e.shiftKey) {
          if (this.activeIndex !== -1) {
            this.cacheActiveIndex = this.activeIndex
          }
          switch (e.keyCode) {
            case 37: // left
              if (!this.selectIndexArr.length) {
                this.selectIndexArr.push(this.activeIndex - 1)
                this.selectIndexArr.push(this.activeIndex)
              } else {
                this.selectIndexArr.unshift(this.selectIndexArr[0] - 1)
              }
              break
            case 39: // right
              if (this.selectIndexArr.length) {
                this.selectIndexArr.shift()
                if (!this.selectIndexArr.length) {
                  this.focusNewTag()
                }
              }
              break
          }
          return
        }
        switch (e.keyCode) {
          case 13: // enter
            this.changeEdit(this.activeIndex)
            break
          case 8: // delete
          case 46: // delete
            if (this.activeIndex !== -1) {
              this.innerTags.splice(this.activeIndex, 1)
            } else {
              const tags = this.innerTags.filter((item, index) => !this.selectIndexArr.includes(index))
              this.innerTags = tags
            }
            this.selectIndexArr = []
            if (!this.innerTags.length || this.activeIndex === this.innerTags.length) {
              this.focusNewTag()
            }
            if (this.activeIndex === this.innerTags.length) {
              this.activeIndex = -1
            }
            break
          case 37: // left
            if (this.selectIndexArr.length) {
              const firstIndex = this.selectIndexArr[0]
              if (firstIndex > 0) {
                this.activeIndex = firstIndex - 1
                return
              }
              this.activeIndex = 0
              return
            }
            this.activeIndex > 0 && this.activeIndex--
            break
          case 39: // right
            if (this.selectIndexArr.length) {
              const lastIndex = this.selectIndexArr[this.selectIndexArr.length - 1]
              if (lastIndex === this.innerTags.length) {
                this.activeIndex = -1
                return this.focusNewTag()
              }
              this.activeIndex = lastIndex
            }
            if (this.activeIndex < this.innerTags.length - 1) {
              return this.activeIndex++
            }
            this.activeIndex = -1
            this.focusNewTag()
            break
        }
        this.tagChange()
      }
    },
    remove(index) {
      this.innerTags.splice(index, 1)
      this.activeIndex = -1
      this.tagChange()
    },
    removeLastTag() {
      if (this.newTag) {
        return
      }
      this.$refs.inputtag.blur()
      if (this.activeIndex === -1) {
        this.activeIndex = this.innerTags.length - 1
        return
      }
      // this.innerTags.pop()
      this.remove(this.activeIndex)
      this.activeIndex--
      this.tagChange()
    },
    tagChange() {
      this.$emit('update:tags', this.innerTags)
      this.$emit('input', this.innerTags)
    }
  },
  mounted() {
    document.addEventListener('keydown', this.changeTag)
    document.addEventListener('click', this.blurTag)
    this.isWin = navigator.platform === 'Win32' || navigator.platform === 'Windows'
    this.isMac = navigator.platform === 'Mac68K' || navigator.platform === 'MacPPC' || navigator.platform === 'Macintosh' || navigator.platform === 'MacIntel'
    document.addEventListener('keydown', this.keydownMounted)
    document.addEventListener('keyup', this.keyupMounted)
  },
  destroyed() {
    document.removeEventListener('keydown', this.changeTag)
    document.removeEventListener('click', this.blurTag)
    document.removeEventListener('keydown', this.keydownMounted)
    document.removeEventListener('keyup', this.keyupMounted)
  }
}
</script>

<style lang="scss">
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
}
.none-select {
  user-select: none;
}
.vue-input-tag-wrapper {
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -o-border-radius: 5px;
  overflow-y: auto;
  padding: 1px 4px;
  cursor: text;
  text-align: left;
  // -webkit-appearance: textfield;
  // display: flex;
  // align-content: flex-start;
  // flex-wrap: wrap;
  transition: all 0.3s;
  max-height: 100px;
  z-index: 10;
  position: relative;
  .input-tag-item {
    line-height: 28px;
    padding-top: 8px;
    padding-left: 8px;
    display: inline-flex;
  }
  .input-tag {
    border-radius: 12px;
    display: inline-block;
    font-size: 13px;
    color: #999;
    // margin-bottom: 3px;
    // margin-right: 6px;
    padding: 4px 16px;
    background: rgba(221, 221, 221, 0.1);
    border: 1px solid rgba(221, 221, 221, 0.5);
    box-sizing: border-box;
    height: 24px;
    line-height: 1;
    // margin-top: 1px;
    cursor: default;
    .remove {
      cursor: pointer;
      // color: #999;
    //   padding-left: 5px;
      position: relative;
      top: -1px;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        text-align: center;
        display: inline-block;
      &:hover {
        text-decoration: none;
        background:#999;
        color: #fff;
      }
      &:empty::before {
        content: ' x';
      }
    }
  }
  // .input-tag::after{
  //   display: block;
  //   content: '';
  //   clear: both;
  // }
  .input-tag-error {
    border-color: #ff6a69;
    background: rgba(255, 106, 105, 0.1);
    color: #ff6a69;
    .remove {
      color: #ff6a69;
    }
  }
  .new-tag {
    background: transparent;
    border: 0;
    color: #999;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 3px;
    outline: none;
    padding: 2px;
    padding-left: 0;
    flex-grow: 1;
    width: calc(100% - 18px);
    height: 45px;
    vertical-align: top;
  }
  .edit-tag {
    position: relative;
    top: -2px;
    background: transparent;
    border: 0;
    color: #777;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 3px;
    outline: none;
    padding: 2px;
    padding-left: 0;
    flex-grow: 1;
    width: 100px;
    height: 14px;
    vertical-align: top;
  }
  .input-tag-active {
    background: rgba(221, 221, 221, 0.5);
  }
}
.vue-input-tag-wrapper.read-only {
  cursor: default;
}
.input-tag-container {
  position: relative;
  border-radius: 5px;
  height: 32px;
  width: 200px;
  .color-alert {
    position: absolute;
    cursor: pointer;
    top: -28px;
    right: 7px;
    color: #f56c6c;
  }
  .del-btn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 20px;
    color:$--color-primary;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
    cursor: pointer;
    .icon-container {
      font-size: 12px;
      position: absolute;
      left: 4px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
}
.input-tag-container--active {
  height: 32px;
  position: relative;
  z-index: 100;
}
.vue-input-tag-wrapper--active {
  position: relative;
  transition: all 0.3s;
  border-color:#e60012;
  box-sizing: border-box;
  width: 100%;
  min-height: 100px;
  left: 0;
  top: 0;
}
</style>
